module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/01/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.01")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("2017年夏天，建筑师一横和太太在上海松江买下了属于自己的第一套房。作为建筑师夫妇，在工作中为业主贡献了无数极具创意和设计感的作品，而在面对自己的家时，他们选择了大白墙为主的极简。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“每天的工作都要在无数的审美中选择，回家后只想要简单。于是我们从设计一开始就定下了设计原则：最少的装饰，最功能化的家具，最省事的家务。”")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("屋主夫妇两人都是建筑师，男主人一横擅于空间整体规划及硬装打磨，女主人则喜欢研究软装功能与色彩搭配。他们信奉密斯·凡德罗Less is more的设计理念，共同打造的家，充满了极简美学和功能主义。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海松江")]), _vm._v(" "), _c('span', [_vm._v("户型：四室两厅")]), _vm._v(" "), _c('span', [_vm._v("使用面积：140㎡")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代极简")]), _vm._v(" "), _c('span', [_vm._v("装修费用：40w+")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img3.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：坐拥三面环景")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("拿到房子以后，一横首先想到的就是将客餐厅打通，并将南阳台包进客厅，形成一个宽敞的、坐拥三面环景的公共区域，最大程度将河景引入室内。白墙基调是窗外风景的最佳图底，公共空间最大化，邀请再多朋友来家Party也不怕。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img4.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("大面积的落地窗，将室内外连为一体。配上可调节光线香格里拉帘，既有百叶一般的光影效果，又方便打理不怕积灰，再加一层白色纱帘，颜值与实用性都可兼顾。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img5.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("白色的墙面与素雅的木纹砖地面，奠定了客餐厅极简的格调，软装的选用则在功能和色彩上做到实用与美观。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("\"我们对家具的选择比较挑剔，喜欢具有实用性与品质感，同时兼具设计感与性价比的。\"说到买家具的经历，夫妻俩在某宝有过多次货不对版的坑，后来经朋友介绍来到懂窝，发现这里的家具与他们的观念不谋而合。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img6.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝维特罗吊灯，星星点点的灯光像花瓣一样，中和极简的设计风格，让整体氛围变得温馨浪漫。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与大体量的沙发形成对比，茶几则选用轻盈的金属元素，精致的平行拉丝和环状拉丝，纹理与材质的细微差别，时尚耐看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img8.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("窗边放一把经典蝴蝶椅，搭配一张懂窝桑德罗羊皮毯，在充满北欧气息的大叶绿植簇拥下，向大师设计致敬，更为自己营造一方闲适空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img9.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅与餐厅之间，以一件蓝灰色的矮柜作为空间过渡，也是入门玄关的视觉落脚点，是一横亲手设计定制的。简约的柜体，加上黄铜底座，轻奢好看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img10.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅遵循简约的设计。懂窝马利克斯餐桌，实木质感温润，冬夏季都有最佳的触感，搭配黄铜桌脚，时尚轻盈。高低排布的吊灯及像圆月般饱满的落地灯，则为用餐提供恰到好处的光源，让气氛更加舒适。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img11.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房：橱柜量身定制")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房与客餐厅相连，带有金属质感的橱柜精致大气，也是一横自己画图、根据家人身高定做的。台柜高度87cm，这样切菜洗碗都不会太累。橱柜下面有可自动感应的灯带，可以从外面控制开关。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img12.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("洗碗机、净水器等电器在最初设计时就被规划入整体橱柜中，加上免拉手的抽屉，在厨房这种重油烟的区域没有一处死角。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：一个多功能柜体")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一个完整精密的收纳系统，是夫妻俩设计这个家的主要考虑之一。为此，一横亲手画图设计了全屋柜体，主要的宗旨是：外无负担，内有乾坤。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门右侧是玄关柜，上部吊柜，放置不常用的杂物；下部高低两个柜体，可以用来放鞋子，中间凹进的部分，刚好可以坐着换鞋。中间设置隐藏的感应灯带。柜体与地面悬空，不仅可以放日常的鞋子，还能让扫地机器人通过。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img13.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("作为玄关延伸的一部分，一面简约的穿衣镜，一幅落地的挂画，让主卧与走廊之间的色彩产生有趣的对话。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img14.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卧：套房设计，收纳力max")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧与主卫、儿童房呈套房设计。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img15.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧有别于客厅的白墙，选择了多乐士的午夜蓝，静谧、深邃如夜空。地板上墙作为床头板，将墙面黄金分割。床头隐藏灯带，加上垂坠的床头灯，让卧室的氛围显得安静而舒适，更加有利于睡眠。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img16.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧内利用墙体凹进的600公分的深度，做了4.8米长的整面柜体。270°的铰链，可以让柜体开门最大化，拿取衣物更加方便。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣柜内搁板可以根据衣物长短进行调节，内置感应灯带，方便衣物挂取。为了杜绝卫生死角，床底架空，方便扫地机器人通过。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img17.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卫：优雅爵士白")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("用爵士白砖铺设主卫，简约明亮。大小两个镜面的设置，方便夫妻俩同时使用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img18.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("蓝灰色的浴室柜也是自己画图定制，台盆半挂，做了400的进深，加上圆镜边缘的灯光，可以带来模拟自然光的效果，方便化妆。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("浴室柜底部做了搁板，可以放置脏衣篮。同时离地面有一定高度，扫地机器人可以通过。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("书房：建筑师的温馨日常")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("书房在进门左侧，这里是两个人的工作空间，也是一个临时客卧（用一张沙发床来实现）。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img19.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一横画图设计了一张3米左右的书桌，满足夫妻俩同时工作的需求。书桌下除了常见的抽屉柜体外，预留了收纳推车（篮子）的空间，可以用来放文件和打印纸等。同时，书房也预留了整整一面墙给未来的书架。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“有的时候设计不能做的太满，未来总是充满了不确定，给设计留点白，也是给自己的生活留点小期盼。” ")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img20.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("现在，一横夫妇已经搬进新家大半年了，无论工作有多辛苦，他们都知道家里有一份简单温馨在等候。每天就着朝霞吃早餐，伴着晚霞做晚饭，厨房不弯腰，没有油烟，连一横也爱上了做饭。每周放扫地机器人出来溜溜，看到看不到的地方都干干净净。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/01/img21.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“很多时候，设计不仅仅只是好看与否，好的设计既可以带给你美的享受，还可以改善你的生活，让你开始享受生活。”")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("软装搭配心得")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  不要单纯看一件单品的好看与否，而是看功能与整体风格的协调性。"), _c('br'), _vm._v(" • 细腿儿的家具可以让地面露出的部分更多，让空间看起来更大。同时也可以让扫地机器人通过，减少做家务的时间。"), _c('br'), _vm._v(" •  定制全屋柜体，充分考虑使用细节，可以将杂物尽量收起来，不影响整体简约的格调。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe7a06b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case1.vue
// module id = 441
// module chunks = 0